// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.competitors-button-secondary {
  background-color: white;
  color: #008CCE;
  border: 1px solid #008CCE;
}

.competitors-button-secondary:hover {
  background-color: white;
  color: #008CCE;
  border: 1px solid #008CCE;
}

.competitors-button-secondary:active {
  background-color: white;
  color: #2ABBFF;
  border: 1px solid #2ABBFF;
  filter: drop-shadow(0px 0px 4px #008CCE);
}

.competitors-button-secondary:disabled {
  border: 1px solid rgba(55, 63, 80, 0.3019607843);
  color: rgba(55, 63, 80, 0.3019607843);
  background-color: white;
}

.competitors-button-primary {
  background-color: #008CCE;
  color: white;
  border: 1px solid #008CCE;
}

.competitors-button-primary:hover {
  background-color: #008CCE;
  color: white;
  border: 1px solid #008CCE;
}

.competitors-button-primary:active {
  background-color: #2ABBFF;
  color: white;
  border: 1px solid #2ABBFF;
  filter: drop-shadow(0px 0px 4px #008CCE);
}

.competitors-button-primary:disabled {
  border: 1px solid #D3D7E0;
  color: rgba(55, 63, 80, 0.3019607843);
  background-color: #D3D7E0;
  filter: none;
}

.competitors-form-control {
  background-color: white;
  color: #56627C;
  border: 1px solid #373F50;
}

.competitors-form-control:focus {
  border: 1px solid #008CCE;
  box-shadow: none;
}

.competitors-form-control:disabled {
  background-color: white;
  border: 1px solid #909BB3;
  color: #909BB3;
}

.error-invalid {
  color: #B00020;
  font-size: 12px;
}

.competitors-form-control-error-invalid {
  color: #B00020;
  border: 1px solid #B00020;
  box-shadow: none;
}

.competitors-form-control.is-invalid {
  color: #B00020 !important;
  border: 1px solid #B00020 !important;
}

.competitors-form-control-error-invalid:active {
  color: #B00020 !important;
  border: 1px solid #B00020 !important;
  box-shadow: none;
  outline: none;
}

.competitors-form-control-error-invalid:focus {
  color: #B00020 !important;
  border: 1px solid #B00020 !important;
  box-shadow: none;
  outline: none;
}

.competitors-form-control.is-invalid:focus {
  color: #B00020 !important;
  border: 1px solid #B00020 !important;
  box-shadow: none;
  outline: none;
}

#demandjumpCompetitors {
  /* form-wrapper */
}
#demandjumpCompetitors .competitor-label {
  width: 30px;
  padding-right: 16px;
}
#demandjumpCompetitors .forms-wizard .nav-item:hover {
  cursor: default;
}
#demandjumpCompetitors .forms-wizard .nav-item a.nav-link:hover {
  cursor: default;
  color: #adb5bd !important;
}
#demandjumpCompetitors .forms-wizard .nav-item.active a.nav-link:hover, #demandjumpCompetitors .forms-wizard .nav-item.done a.nav-link:hover {
  color: #495057 !important;
}
#demandjumpCompetitors .form-wrapper {
  max-width: 500px;
  width: 100%;
  margin-top: 48px;
  margin-bottom: 48px;
}
#demandjumpCompetitors .form-wrapper .demandjump-competitors-control {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#demandjumpCompetitors .form-wrapper .demandjump-competitors-control .competitor-label {
  width: 30px;
}
#demandjumpCompetitors .form-wrapper .demandjump-competitors-control label {
  margin-right: 4px;
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: 0.4px;
  color: rgba(0, 0, 0, 0.6);
  width: 24px;
}
#demandjumpCompetitors .form-wrapper .demandjump-competitors-control input {
  width: 100%;
}
#demandjumpCompetitors .confirm-content {
  margin: 32px 0;
}
#demandjumpCompetitors .confirm-content p {
  margin: 0;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.43;
}

/* #demandjumpCompetitors */`, "",{"version":3,"sources":["webpack://./src/components/settings/Competitors/competitors.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,wCAAA;AACF;;AAEA;EACE,gDAAA;EACA,qCAAA;EACA,uBAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,yBAAA;EACA,wCAAA;AACF;;AAEA;EACE,yBAAA;EACA,qCAAA;EACA,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,oCAAA;AACF;;AAEA;EACE,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EA6DE,iBAAA;AA3DF;AAAE;EACE,WAAA;EACA,mBAAA;AAEJ;AAGM;EACE,eAAA;AADR;AAIM;EACE,eAAA;EACA,yBAAA;AAFR;AAOQ;EACE,yBAAA;AALV;AAWE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AATJ;AAWI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AATN;AAWM;EACE,WAAA;AATR;AAYM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;AAVR;AAaM;EACE,WAAA;AAXR;AAmBE;EACE,cAAA;AAjBJ;AAmBI;EACE,SAAA;EACA,yBAAA;EACA,iBAAA;AAjBN;;AAsBA,2BAAA","sourcesContent":[".competitors-button-secondary {\n  background-color: white;\n  color: #008CCE;\n  border: 1px solid #008CCE;\n}\n\n.competitors-button-secondary:hover {\n  background-color: white;\n  color: #008CCE;\n  border: 1px solid #008CCE;\n}\n\n.competitors-button-secondary:active {\n  background-color: white;\n  color: #2ABBFF;\n  border: 1px solid #2ABBFF;\n  filter: drop-shadow(0px 0px 4px #008CCE);\n}\n\n.competitors-button-secondary:disabled {\n  border: 1px solid #373F504D;\n  color: #373F504D;\n  background-color: white;\n}\n\n.competitors-button-primary {\n  background-color: #008CCE;\n  color: white;\n  border: 1px solid #008CCE;\n}\n\n.competitors-button-primary:hover {\n  background-color: #008CCE;\n  color: white;\n  border: 1px solid #008CCE;\n}\n\n.competitors-button-primary:active {\n  background-color: #2ABBFF;\n  color: white;\n  border: 1px solid #2ABBFF;\n  filter: drop-shadow(0px 0px 4px #008CCE);\n}\n\n.competitors-button-primary:disabled {\n  border: 1px solid #D3D7E0;\n  color: #373F504D;\n  background-color: #D3D7E0;\n  filter: none;\n}\n\n.competitors-form-control {\n  background-color: white;\n  color: #56627C;\n  border: 1px solid #373F50;\n}\n\n.competitors-form-control:focus {\n  border: 1px solid #008CCE;\n  box-shadow: none;\n}\n\n.competitors-form-control:disabled {\n  background-color: white;\n  border: 1px solid #909BB3;\n  color: #909BB3\n}\n\n.error-invalid {\n  color: #B00020;\n  font-size: 12px;\n}\n\n.competitors-form-control-error-invalid {\n  color: #B00020;\n  border: 1px solid #B00020;\n  box-shadow: none;\n}\n\n.competitors-form-control.is-invalid {\n  color: #B00020 !important;\n  border: 1px solid #B00020 !important;\n}\n\n.competitors-form-control-error-invalid:active {\n  color: #B00020 !important;\n  border: 1px solid #B00020 !important;\n  box-shadow: none;\n  outline: none;\n}\n\n.competitors-form-control-error-invalid:focus {\n  color: #B00020 !important;\n  border: 1px solid #B00020 !important;\n  box-shadow: none;\n  outline: none;\n}\n\n.competitors-form-control.is-invalid:focus {\n  color: #B00020 !important;\n  border: 1px solid #B00020 !important;\n  box-shadow: none;\n  outline: none;\n}\n\n#demandjumpCompetitors {\n\n  .competitor-label {\n    width: 30px;\n    padding-right: 16px;\n  }\n\n  .forms-wizard {\n    .nav-item {\n      &:hover {\n        cursor: default;\n      }\n\n      a.nav-link:hover {\n        cursor: default;\n        color: #adb5bd !important;\n      }\n\n      &.active,\n      &.done {\n        a.nav-link:hover {\n          color: #495057 !important;\n        }\n      }\n    }\n  }\n\n  .form-wrapper {\n    max-width: 500px;\n    width: 100%;\n    margin-top: 48px;\n    margin-bottom: 48px;\n\n    .demandjump-competitors-control {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      .competitor-label {\n        width: 30px;\n      }\n\n      label {\n        margin-right: 4px;\n        font-size: 12px;\n        font-weight: 400;\n        font-style: normal;\n        font-stretch: normal;\n        line-height: 1.33;\n        letter-spacing: .4px;\n        color: rgba(0, 0, 0, .6);\n        width: 24px;\n      }\n\n      input {\n        width: 100%;\n        // padding-right: 24px;\n      }\n    }\n  }\n\n  /* form-wrapper */\n\n  .confirm-content {\n    margin: 32px 0;\n\n    p {\n      margin: 0;\n      color: rgba(0, 0, 0, 0.6);\n      line-height: 1.43;\n    }\n  }\n}\n\n/* #demandjumpCompetitors */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
